import checkBankStatus from '../../../../api/bank/checkStatusAppeal';
import Button from '../../../../components/Button/Button';
import FormHeading from '../../../../components/Typography/FormHeading';
import CheckBankStatus from './CheckBankStatus';

const WaitingForNewBankStatus = ({ chunkId, bankId, setLoading, onSuccess }) => {
  return (
    <div>
      <FormHeading>ÐÐ¶Ð¸Ð´Ð°Ð½Ð¸Ðµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹ Ð½Ð° ÑÑÐ¾ÑÐ¾Ð½Ðµ Ð±Ð°Ð½ÐºÐ°</FormHeading>
      <CheckBankStatus bankId={bankId} onSuccess={onSuccess} chunkId={chunkId} setLoading={setLoading}/>
    </div>
  );
};

export default WaitingForNewBankStatus;
